import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQ = () => {
  const [openQuestion, setOpenQuestion] = useState(null);
  const toggleQuestion = index => {
    if (openQuestion === index) {
      setOpenQuestion(null);
    } else {
      setOpenQuestion(index);
    }
  };
  const faqs = [{
    question: 'How Can I Contact Customer Support?',
    answer: <div data-id="element-365">
          <p data-id="element-366">You can reach us by:</p>
          <ul className="list-disc ml-6 mt-2" data-id="element-367">
            <li data-id="element-368">
              Email:{' '}
              <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#f05a28] hover:underline" data-id="element-369">
                sunitalimbu9596@gmail.com
              </a>
            </li>
            <li data-id="element-370">
              Phone:{' '}
              <a href="tel:08000554969" className="text-[#f05a28] hover:underline" data-id="element-371">
                0800 055 4969
              </a>
            </li>
          </ul>
          <p className="mt-2" data-id="element-372">
            Our support team is available Monday to Friday from 9 am to 5 pm.
            Messages received outside these hours will be responded to on the
            next working day.
          </p>
        </div>
  }, {
    question: 'When Does My Service Plan Start and End?',
    answer: <div data-id="element-373">
          <p data-id="element-374">
            Your Peakwave coverage begins as soon as your payment is confirmed.
          </p>
          <p className="mt-2" data-id="element-375">
            <strong data-id="element-376">Activation:</strong> Your plan activates immediately after
            payment clears. A confirmation email will be sent straight away. No
            further action is needed on your part.
          </p>
          <p className="mt-2" data-id="element-377">
            <strong data-id="element-378">Coverage:</strong> Lasts for 12 months from the purchase
            date.
          </p>
          <p className="mt-2" data-id="element-379">
            <strong data-id="element-380">Expiry:</strong> Your plan ends exactly 12 months later at
            23:59, unless you choose to renew for continuous protection.
          </p>
        </div>
  }, {
    question: 'How Do I Request a Repair?',
    answer: <div data-id="element-381">
          <p data-id="element-382">Contact Peakwave at:</p>
          <ul className="list-disc ml-6 mt-2" data-id="element-383">
            <li data-id="element-384">
              📞{' '}
              <a href="tel:08000554969" className="text-[#f05a28] hover:underline" data-id="element-385">
                0800 055 4969
              </a>
            </li>
            <li data-id="element-386">
              📧{' '}
              <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#f05a28] hover:underline" data-id="element-387">
                sunitalimbu9596@gmail.com
              </a>
            </li>
          </ul>
          <p className="mt-2" data-id="element-388">
            We typically schedule repair appointments within 24 to 48 hours.
          </p>
        </div>
  }, {
    question: "What Does 'Unlimited Repairs' Mean?",
    answer: <div data-id="element-389">
          <p data-id="element-390">
            You may request unlimited repair visits and technician time for all
            essential appliances covered under your Peakwave plan.
          </p>
          <p className="mt-2" data-id="element-391">
            <strong data-id="element-392">Please note:</strong> Appliances older than 10 years,
            accidental or liquid damage, and general wear and tear not caused by
            mechanical or electrical faults are excluded.
          </p>
        </div>
  }, {
    question: 'Cooling-Off and Refunds',
    answer: <div data-id="element-393">
          <p data-id="element-394">
            Yes. You can cancel within 14 days of purchase for a full refund,
            provided no repair work has started.
          </p>
          <p className="mt-2" data-id="element-395">
            Cancellations made between days 15 and 28 may be eligible for a
            partial refund, at our discretion, taking into account any services
            already rendered.
          </p>
          <p className="mt-2" data-id="element-396">No refunds are offered after 28 days.</p>
          <p className="mt-2" data-id="element-397">
            To cancel, email{' '}
            <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#f05a28] hover:underline" data-id="element-398">
              sunitalimbu9596@gmail.com
            </a>{' '}
            or call{' '}
            <a href="tel:08000554969" className="text-[#f05a28] hover:underline" data-id="element-399">
              0800 055 4969
            </a>{' '}
            with your order number.
          </p>
          <p className="mt-2" data-id="element-400">
            Refunds will be processed to your original payment method within 7
            to 10 working days.
          </p>
        </div>
  }, {
    question: 'What Appliances and Faults Are Covered?',
    answer: <div data-id="element-401">
          <p data-id="element-402">
            <strong data-id="element-403">Included:</strong> Mechanical and electrical faults on
            registered appliances (e.g., breakdowns, faulty components).
          </p>
          <p className="mt-2" data-id="element-404">
            <strong data-id="element-405">Excluded:</strong> Accidental or liquid damage, unregistered
            appliances, and appliances exceeding the age limit.
          </p>
        </div>
  }, {
    question: 'How Quickly Can I Book an Appointment?',
    answer: <div data-id="element-406">
          <p data-id="element-407">
            We aim to respond within 48 hours to arrange a visit. Most local
            repairs are booked within 3 to 5 working days.
          </p>
          <p className="mt-2" data-id="element-408">
            For remote locations or busy periods, scheduling may take longer,
            but we will discuss alternative timings with you.
          </p>
        </div>
  }, {
    question: 'Do You Cover the Whole UK?',
    answer: <div data-id="element-409">
          <p data-id="element-410">Yes. Our services cover England, Scotland, and Wales.</p>
          <p className="mt-2" data-id="element-411">
            Please check availability for remote postcodes before purchasing.
          </p>
        </div>
  }, {
    question: 'If a Repair Does Not Resolve the Fault',
    answer: <div data-id="element-412">
          <p data-id="element-413">
            Contact Peakwave immediately. If the issue cannot be fixed after
            reasonable attempts, you may qualify for a pro-rated refund or
            replacement credit for faults reported within three years.
          </p>
        </div>
  }, {
    question: 'Payment Methods Accepted',
    answer: <div data-id="element-414">
          <p data-id="element-415">We accept:</p>
          <ul className="list-disc ml-6 mt-2" data-id="element-416">
            <li data-id="element-417">Credit and debit cards (Visa, Mastercard)</li>
            <li data-id="element-418">Apple Pay and Google Pay</li>
            <li data-id="element-419">BACS or Direct Debit</li>
            <li data-id="element-420">Cheques (by post, please contact us for details)</li>
          </ul>
          <p className="mt-2" data-id="element-421">
            All payments are processed in GBP upon confirmation.
          </p>
        </div>
  }, {
    question: 'Which Plan Should I Choose?',
    answer: <div data-id="element-422">
          <p data-id="element-423">
            Peakwave offers various service plans tailored to different
            household needs and appliance types.
          </p>
          <ul className="list-disc ml-6 mt-2" data-id="element-424">
            <li data-id="element-425">One-Appliance Plan – covers a single item</li>
            <li data-id="element-426">
              Multi-Appliance Plans – ideal for homes with several appliances
            </li>
          </ul>
          <p className="mt-2" data-id="element-427">
            For full details, see our Service Plans & Pricing page or contact us
            for advice.
          </p>
        </div>
  }, {
    question: 'Dispute Resolution',
    answer: <div data-id="element-428">
          <p data-id="element-429">
            If you have concerns about payments or services, please contact our
            support team first at{' '}
            <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#f05a28] hover:underline" data-id="element-430">
              sunitalimbu9596@gmail.com
            </a>{' '}
            or call{' '}
            <a href="tel:08000554969" className="text-[#f05a28] hover:underline" data-id="element-431">
              0800 055 4969
            </a>{' '}
            before raising any bank disputes.
          </p>
          <p className="mt-2" data-id="element-432">
            We are committed to resolving issues quickly and fairly. Initiating
            chargebacks without prior contact may delay refunds.
          </p>
        </div>
  }, {
    question: 'How Will I Receive My Refund?',
    answer: <div data-id="element-433">
          <p data-id="element-434">
            Refunds are credited to your original payment method. You will
            receive confirmation once processed.
          </p>
        </div>
  }];
  return <div className="w-full" data-id="element-435">
      {/* Hero Section */}
      <section className="bg-[#0a2e4a] text-white py-16" data-id="element-436">
        <div className="container mx-auto px-4" data-id="element-437">
          <div className="max-w-3xl mx-auto text-center" data-id="element-438">
            <h1 className="text-4xl font-bold mb-6" data-id="element-439">
              Frequently Asked Questions
            </h1>
            <p className="text-xl" data-id="element-440">
              Find answers to common questions about our appliance repair
              services
            </p>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-16" data-id="element-441">
        <div className="container mx-auto px-4" data-id="element-442">
          <div className="max-w-3xl mx-auto" data-id="element-443">
            <p className="text-lg text-gray-600 mb-10 text-center" data-id="element-444">
              Here you'll find answers to common questions about Peakwave's
              appliance repair services and service plans. We aim to be as
              transparent as possible to give you complete peace of mind.
            </p>
            <div className="space-y-4" data-id="element-445">
              {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-446">
                  <button className={`w-full text-left p-5 flex justify-between items-center focus:outline-none ${openQuestion === index ? 'bg-[#e6f4fa]' : 'bg-white'}`} onClick={() => toggleQuestion(index)} data-id="element-447">
                    <span className="text-lg font-semibold text-[#0a2e4a]" data-id="element-448">
                      {faq.question}
                    </span>
                    {openQuestion === index ? <ChevronUp className="text-[#0a2e4a]" size={20} data-id="element-449" /> : <ChevronDown className="text-[#0a2e4a]" size={20} data-id="element-450" />}
                  </button>
                  {openQuestion === index && <div className="p-5 border-t border-gray-200 bg-white" data-id="element-451">
                      <div className="text-gray-600" data-id="element-452">{faq.answer}</div>
                    </div>}
                </div>)}
            </div>
          </div>
        </div>
      </section>
      {/* Contact CTA Section */}
      <section className="py-16 bg-gray-50" data-id="element-453">
        <div className="container mx-auto px-4" data-id="element-454">
          <div className="max-w-3xl mx-auto text-center" data-id="element-455">
            <h2 className="text-3xl font-bold text-[#0a2e4a] mb-6" data-id="element-456">
              Still Have Questions?
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-457">
              Our customer support team is ready to help with any additional
              questions you may have about our services.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-458">
              <a href="tel:08000554969" className="bg-[#0a2e4a] text-white px-8 py-3 rounded-md font-semibold text-center hover:bg-[#164875] transition" data-id="element-459">
                Call Us: 0800 055 4969
              </a>
              <a href="/contact" className="bg-[#f05a28] text-white px-8 py-3 rounded-md font-semibold text-center hover:bg-[#d94e20] transition" data-id="element-460">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default FAQ;